<template>
  <q-dialog v-model="downloadSchemeReport" class="share-grants-page">
    <q-card class="share-dialog">
      <q-card-section>
        <div class="text-h5 text-main bold-font">
          Downloaden geselecteerde items als een rapport
        </div>
      </q-card-section>
      <q-card-section>
        <div class="row justify-between top-section-responsive">
          <div class="column column-width">
            <span class="input-heading"> Rapporttitel * </span>
            <q-input
              class="q-mt-sm"
              borderless
              bg-color="white"
              v-model="reportTitle"
              dense
              :rules="requiredFieldRule"
            />

            <span class="input-heading q-mt-md"> Omschrijving </span>
            <q-input
              class="q-mt-sm"
              v-model="description"
              borderless
              bg-color="white"
              type="textarea"
            />
          </div>
        </div>
      </q-card-section>

      <q-card-section class="report-type">
        <q-select
          square
          borderless
          bg-color="white"
          v-model="reportType"
          :options="options"
          label="Type rapport"
          style="width: 47%"
        />
      </q-card-section>

      <q-card-actions class="q-mt-sm bold-font" align="left">
        <q-btn
          flat
          no-caps
          label="Downloaden"
          class="orange-btn-filled"
          @click="
            downloadScheme(
              updateSchemeToDownload,
              reportTitle,
              description,
              customerName,
              reportType
            )
          "
        />
        <q-btn
          no-caps
          flat
          label="Annuleren"
          class="orange-btn-cancel"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from 'vue';
import store from '../../store/index';
import authHeader from '../../helpers/auth-header';

export default {
  setup() {
    const updateSchemeToDownload = computed({
      get: () => store.state.grantItems.schemeToDownload,
    });

    const downloadSchemeReport = computed({
      get: () => store.state.grantItems.downloadSchemeReport,
      set: (val) => store.commit('grantItems/disableDownloadSchemeReport', val),
    });

    const downloadScheme = async (
      schemeId,
      reportTitle,
      description,
      customerName,
      reportType
    ) => {
      if (reportTitle == '') {
        return;
      }
      const ids = schemeId;
      let form = document.createElement('form');
      form.method = 'post';
      form.target = '_blank';
      form.action = `/api/download/downloadSchemes`;
      form.innerHTML = `'<input type="hidden" name="jwtToken" value="${
        authHeader().Authorization
      }">
                         <input type="hidden" name="reportType" value="${
                           reportType.value
                         }">
                         <input type="hidden" name="ids" value="${ids}">
                         <input type="hidden" name="reportTitle" value="${reportTitle}">
                         <input type="hidden" name="reportDescription" value="${description}">
                         <input type="hidden" name="customerName" value="${customerName}">'`;
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
      store.commit('grantItems/disableDownloadSchemeReport');
    };

    const reportTitle = ref('');
    const description = ref('');
    const customerName = ref('');

    const reportType = ref({
      label: 'Volledig rapport',
      value: 0,
    });

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const custid = computed({
      get: () => store.state.auth.custid,
    });
    const reportOptions = [
      {
        label: 'Volledig rapport',
        value: 0,
      },
      {
        label: 'Alleen kerngegevens',
        value: 10,
      },
      {
        label: 'Kerngegevens en samenvattingen',
        value: 20,
      },
    ];
    if (isVind.value && custid.value == 2) {
      reportOptions.push({
        label: 'Screening rapport',
        value: 30,
      });
    }
    return {
      options: reportOptions,
      isVind,
      reportType,
      downloadSchemeReport,
      downloadScheme,
      updateSchemeToDownload,
      customerName,
      description,
      reportTitle,

      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern =
          /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Ongeldig e-mailadres';
      },
    };
  },
};
</script>
